import { render, staticRenderFns } from "./Profession.vue?vue&type=template&id=675da88c&scoped=true"
import script from "./Profession.vue?vue&type=script&lang=js"
export * from "./Profession.vue?vue&type=script&lang=js"
import style0 from "./Profession.vue?vue&type=style&index=0&id=675da88c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675da88c",
  null
  
)

export default component.exports